import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import { getCompletionStepUserPermissions } from '../../../helpers/permissions/CompletionStepPermissionsUtil';

import dataModel from '../../../models/DataModel';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';

import UserAvatarWithInfo from '../../../components/UserAvatar/UserAvatarWithInfo';
import UserAvatar from '../../../components/UserAvatar';
import MultipleUserPopup from '../../../components/MultipleUserPopup';
import TaskCompletionSteps from './TaskCompletionSteps';
import DocumentsList from '../../../components/TaskCRUD/DocumentsList';
import ExpandableSection from '../../../components/ExpandableSectionDocuments';
import AttachmentHelper from '../../../helpers/AttachmentHelper';
import TaskInventory from './TaskInventory';
import FileUtil from '../../../helpers/FileUtil/FileUtil';
import AddIcon from '../../../components/Iconoclast/AddIcon';
import TextMap from '../../../helpers/TextMap';
import MobileAssignmentTab from './MobileAssignmentTab';
import * as BuildOwnerPermissionsUtil from '../../../helpers/permissions/BuildOwnerPermissionsUtil';
import DataSource from '../../../dao/DataSource/DataSource';

import styles from '../../../assets/styles/globals.scss';
import VideoPlayer from '../../../components/VideoPlayer';
import './MobileTaskDetails.scss';

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

const taskDescriptor = {
  task: {
    build: {},
    user_task_assignments: {
      user: { 
        companies: {},
      },
    },
    reference_documents: {},
    inventory_items: {
      inventory: {},
    },
  },
};

export class MobileTaskDetails extends BaseComponent {

  constructor(props) {
    super(props);

    MobileTaskDetails.propTypes = {
      task: PropTypes.object.isRequired,
    };

    this.animator = new animator();
    this.state = {
      displayedInfo: null,
      userStepPermissions: new Set(),
      display: 'task',
      userTaskPermissions: false,
      displayDatePopup: false,
    };
    const { currentUser } = props;

    this.textMap = new TextMap();
    const currentRole = currentUser && currentUser.role ? currentUser.role : null;
    this.currentUserRoleName = currentRole ? currentRole.name : null;
    this.validImageTypes = ['jpg','jpeg','png','svg'];
    this.validVideoTypes = ['mp4','m4v','wmv','mpeg','flv','mov','qt','mp4v'];
    this.currentUserCompanyId = currentUser.primary_company ? currentUser.primary_company.id : parseInt(localStorage.primary_company_id, 10);

    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: true,
    });
  }

  handleUpdateTask(task, action) {
    this.setState({ task });
    if (action != 'prefetch') {
      this.determineUserStepPermissions();
      this.determineTaskUserPermissions();
    }
  }

  componentDidMount() {
    this.inventoryEnabled = this.props.currentCompany.features && this.props.currentCompany.features.inventory && this.props.currentCompany.features.inventory.enabled;
    this.taskDataSource = new DataSource('Task', this.props.task.id, taskDescriptor, this.handleUpdateTask);
    this.taskDataSource.get();

  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }
  componentDidUpdate() {
  
  }

  convertTaskStatus(task){
    return task.status.split('_').map(word => word.substr(0,1).toUpperCase() + word.substr(1).toLowerCase()).join(' ');
  }

  handleOpenDoc(referenceDocument){
    if (referenceDocument) {
      if (referenceDocument.group_identifier) {
        dataModel.referenceDocumentsDAO.getReferenceDocument(referenceDocument.id,
          { recordDescriptor: { reference_document: { conversions: { } } } }).then((refDoc) => {
            this.setState({ displayRefDoc: refDoc });
            this.props.handleRefDocOpen();
          });
      }
      else {
        dataModel.uniqueDocumentsDAO.getUniqueDocument(referenceDocument.id,
          { recordDescriptor: { unique_document: { conversions: { } } } }).then((refDoc) => {
            this.setState({ displayRefDoc: refDoc });
            this.props.handleRefDocOpen();
          });
      }
    }
  }

  determineUserStepPermissions() {
    // view can be 'projects' or 'tasks'
    
    const {
      currentCompany,
      currentUser,
      isBuildOwner,
      project,
    } = this.props;
    const { task } = this.state;

    const stepPermissions = getCompletionStepUserPermissions({
      currentCompany,
      currentUser,
      isBuildOwner,
      project,
      task,
      view: 'tasks',
      isVendor: currentUser.is_vendor_user,
    });

    this.setState({ userStepPermissions: stepPermissions });
  }

  determineTaskUserPermissions() {
    const { currentUser, currentCompany } = this.props;
    const { task } = this.state;
    let hasPermissions = false;

    if (this.currentUserCompanyId == currentCompany.id && (this.currentUserRoleName == 'editor' || this.currentUserRoleName == 'admin')) {
      hasPermissions = true;
    }

    //if user is build owner of current project AND is build owner of current build 
    //AND does not have the primary company of the current company
    else if (
      currentUser
      && task
      && task.build_owner_ids
      && task.build_owner_ids.filter(bowner_id => { return bowner_id == currentUser.id; }).length
      && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(currentCompany, currentUser)
    ) {
      this.isBuildOwner = true;
      hasPermissions = true;
    }
    this.setState({ userTaskPermissions: hasPermissions });
  }

  handleCheckIsImage(attachment) {
    let ext = FileUtil.getExtension(attachment.name);
    return this.validImageTypes.includes(ext.toLowerCase());
  }

  handleCheckIsVideo(attachment) {
    if (attachment.attachment_content_type) {
      return attachment.attachment_content_type.toLowerCase().startsWith('video');
    }
    let ext = FileUtil.getExtension(attachment.name);
    return this.validVideoTypes.includes(ext.toLowerCase());
  }

  handleInfoDisplay(assignment) {
    this.setState({ displayedInfo: assignment });
  }

  handleInfoClose() {
    this.setState({ displayedInfo: null });
  }

  handlePopupInventoryAdd() {
    this.props.history.push({ pathname: '/mobile/inventory/' + this.state.task.id });
  }

  handleEditInventoryItem(inventoryItem) {
    this.props.history.push({ pathname: '/mobile/inventory/' + this.state.task.id + '/edit/' + inventoryItem.id });
  }

  handleCancelInventoryAdd() {
    this.setState({ displayInventoryAdd: false });
  }

  handleToggleNav(display) {
    this.setState({ display });
  }

  handleDisplayPhotoCarousel(task, completionStep) {
    const { userStepPermissions } = this.state;
    let pathName = `/mobile/projects-tasks/task/${completionStep.task_id}/completion_step/${completionStep.id}/photo-display/all`;
    this.props.history.push({
      pathname: pathName,
      state: { 
        userStepPermissions: userStepPermissions,
      },
    });
  }

  handleCreateUserDisplay(task, userArray,
    assignment_type,
    title, position,
    allowAdd) {
    let userDisplay = null;
    task.user_task_assignments.filter(assignment => {
      if (assignment) {
        if (assignment.assignment_type == assignment_type) {
          userArray.push(assignment.user);
          return true;
        }
        return false;
      }
      return false;
    });
  
    if (userArray.length > 1) {
      userDisplay = 
          <div>
            <UserAvatar handleSelected={() => this.handleInfoDisplay(assignment_type)} larger={true} multiAssigned={true}/>
          <div className='assignment-label'>{title}</div>
            {this.state.displayedInfo == assignment_type &&
              <MultipleUserPopup
                handleCloseClicked={this.handleInfoClose}  
                isMobile={true}
                title={title}
                users={userArray}
                trianglePosition={position}
              />
            }
          </div>;
    }
    else if (userArray.length == 1){
      userDisplay =
        <div>
          <UserAvatarWithInfo user={userArray[0]} largest={false} larger={true} handleInfoOpen={this.handleInfoDisplay} assignment={assignment_type} displayed={this.state.displayedInfo} handleInfoClose={this.handleInfoClose} />
          <div className='assignment-label'>{title}</div>
        </div>;
    } else if (allowAdd && userArray.length == 0 && this.state.userTaskPermissions) {
      userDisplay =
        <div className='add-assigned-to' onClick={() => this.handleToggleNav('assignments')}>
          <AddIcon outlineType={'dashed'} width={21} height={21} iconColor={styles.aoDarkBlue}/>
          <p className='add-assigned-to-text'>{title}</p>
        </div>;
    }
    return userDisplay;
  }
  
  handleMarkAll(status) {
    //should I do a props.handleUpdate here too?
    switch (status) {
    case 'na':
      this.taskDataSource.performAction('markTaskNA', this.state.task);
      this.analyticsLogger.logCSCompletion('TaskNotApplicable');
      break;
    case 'un-na':
      this.taskDataSource.performAction('unmarkTaskNA', this.state.task);
      this.analyticsLogger.logCSCompletion('TaskN/AUndo');
      break;
    default:
      break;
    }
  }

  checkAllNA(task) {
    let allNa = true;
    task.completion_criteria.filter(cc => {
      if (allNa && (!cc.not_applicable && cc.response != 'N/A')) {
        allNa = false;
      }
      return cc.not_applicable || (cc.completion_type == 'inspection' && cc.response == 'N/A');
    });
    return allNa;
  }

  handleToggleDatePopup(e) {
    e.stopPropagation();
    this.setState({ displayDatePopup: !this.state.displayDatePopup });
  }

  handleHideDatePopup() {
    this.setState({ displayDatePopup: false });
  }

  render() {
    const { project } = this.props;
    const { userStepPermissions, task } = this.state;

    if (!task) {
      return null;
    }
    let completed = 0;
    let attachmentCount = task.task_attachments_count;
    const total = task.completion_criteria ? task.completion_criteria.length : 0;
    if (total > 0) {
      completed = task.completion_criteria.filter(cc => {
        return cc && cc.completed_at;
      }).length;
    }
    let assignedTo, reviewers, approvers;
    let refDoc, style;
    let fieldUsers = [];
    let approverUsers = [];
    let reviewerUsers = [];
    
    assignedTo = this.handleCreateUserDisplay(task, fieldUsers,
      'field_user', 'Assigned To',
      (task.has_approver || task.has_reviewer) ? 'left' : 'middle',
      true);

    reviewers = this.handleCreateUserDisplay(task, reviewerUsers,
      'reviewer', 'Reviewer',
      (task.has_field_user || task.has_approver) ? 'middle' : 'left',
      false);

    approvers = this.handleCreateUserDisplay(task, approverUsers,
        'approver', 'Approver',
        (task.has_field_user && task.has_reviewer) ? 'right' : 'middle',
        false);

    let status = this.convertTaskStatus(task);
    let leftAssignment, middleAssignment, rightAssignment;
    let userAvatars = [];
    if (assignedTo) {
      userAvatars.push(assignedTo);
    }
    if (reviewers) {
      userAvatars.push(reviewers);
    }
    if (approvers) {
      userAvatars.push(approvers);
    }
    if (userAvatars.length == 1) {
      middleAssignment = userAvatars[0];
    }
    else {
      leftAssignment = userAvatars[0] || null;
      middleAssignment = userAvatars[1] || null;
      rightAssignment = userAvatars[2] || null;
    }

    if(this.props.refDocOpen){
      let referenceDocument = this.state.displayRefDoc;
      let content;
      let isImage = this.handleCheckIsImage(referenceDocument);
      if (!isImage) {
        if (this.handleCheckIsVideo(referenceDocument)) {
          const attachment = referenceDocument.attachment;
          const type = attachment && attachment.upload_content_type ? attachment.upload_content_type : (attachment && attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
          content = <VideoPlayer src={referenceDocument.attachment} width={window.innerWidth - 20} height={328} type={type}/>;
        } else {
          content = AttachmentHelper.getConvertedDocumentView(referenceDocument);
        }
      }
      else {
        content = <img className="display-ref-doc" src={referenceDocument.attachment} alt={'Reference Doc'}/>;
      }
      refDoc = (
        <div className='ref-doc'>
          {content}
        </div>
      );
      style = { display: 'none' };
    }

    let bigMarkUnmarkNAButton;
    if (task.completion_criteria && task.completion_criteria.length > 0 && (userStepPermissions.has('can_mark_all') || userStepPermissions.has('mark_as_complete') || userStepPermissions.has('mark_as_approved') || userStepPermissions.has('mark_as_reviewed') ||
      userStepPermissions.has('step_complete') || userStepPermissions.has('unmarkNA') || userStepPermissions.has('override'))) {
      if (task.status == 'not_started') {
        bigMarkUnmarkNAButton = (
          <div
            className="mobile-approve-all-button na-button"
            onClick={() => this.handleMarkAll('na')}
          >
            MARK ALL AS NA
      </div>
        );
      }
      else if (this.checkAllNA(task) && (task.status != 'completed' || userStepPermissions.has('unmarkNA'))) {
        bigMarkUnmarkNAButton = (
          <div
            className="mobile-approve-all-button na-button"
            onClick={() => this.handleMarkAll('un-na')}
          >
            UNMARK ALL AS NA
      </div>
        );
      }
    }

    let taskCompletion = null;
    let calendarIcon = null;
    if (task.estimated_completion_date || task.actual_completion_date) {
      let estimatedCompletionDate = formatDate(task.actual_completion_date ? task.actual_completion_date : task.estimated_completion_date);
      const overdue = !task.actual_completion_date && new Date(estimatedCompletionDate) < new Date() ? ' overdue' : '';
      const completed = task.status == 'not_started' || task.status == 'in_progress' ? '' : ' completed';
      calendarIcon = <div className={'calendar-icon' + overdue + completed} />;
      const whichDatePopup = <div className="which-date-popup" onClick={this.handleToggleDatePopup}>{task.actual_completion_date ? 'Actual Completion Date' : 'Projected Completion Date'}</div>;
      const displayDatePopup = this.state.displayDatePopup ? ' display-date-popup' : '';
      taskCompletion = <div className={'completion-date-container' + displayDatePopup} onClick={this.handleToggleDatePopup}>
        <div className={'completion-date' + overdue}>{estimatedCompletionDate}</div>
        {whichDatePopup}
      </div>;
    }
    return (
      <div className="task-detail-container" id="task-detail-container" onClick={this.handleHideDatePopup}>
        {refDoc}
        <div style={style}>
          <div className='task-details-header'>
            <div className="task-name">{task.name}</div>
            <div className="project-name">{project ? project.name : 'No project name'}</div>
            <div className="project-name">{task.build ? task.build.name : 'No build name'}</div>
            <div className='details-bottom-row'>
              <div className='attachment-icon' />
              <div className='attachments'>{attachmentCount}</div>
              <div className='completion-icon' />
              <div className='completion-steps'>{`${completed}/${total}`}</div>
              {calendarIcon}
              {taskCompletion}
              <div className={`status ${task._dirty ? 'offline': task.status}`}>{task._dirty ?  'Offline' : status}</div>
            </div>
          </div>
          {
            this.state.userTaskPermissions == true &&
            <nav className='task-details-nav'>
              <button 
                className={ 'task-details-button' + (this.state.display == 'task' ? ' task-details-button--selected' : '') }
                onClick={() => this.handleToggleNav('task')}
              >
                { this.textMap.task.toUpperCase() }
              </button>
              <button 
                className={ 'task-details-button' + (this.state.display == 'assignments' ? ' task-details-button--selected' : '') } 
                onClick={() => this.handleToggleNav('assignments')}
              >
                { this.textMap.assignments.toUpperCase() }
              </button>
            </nav>
          }
          {
            this.state.display == 'task' &&
            <div    className='tasks-tab-container'>
              <div className='user-avatars'>
                <div className='assignment assignment__left'>
                  {leftAssignment}
                </div>
                <div className='divider' />
                <div className='assignment assignment__middle'>
                  {middleAssignment}
                </div>
                <div className='divider' />
                <div className='assignment assignment__right'>
                  {rightAssignment}
                </div>
              </div>
              { task.notes &&
                <div className='description'>
                  <div className='description-label'>Description</div>
                  <div className='description-notes'>{task.notes}</div>
                </div>
              }
              <TaskCompletionSteps
                task={task}
                userStepPermissions={this.state.userStepPermissions}
                isBuildOwner={this.isBuildOwner}
                view={'tasks'}
                displayPhotoCarousel={this.handleDisplayPhotoCarousel}
              />
              {bigMarkUnmarkNAButton}
              <ExpandableSection name='DOCUMENTS' id="docs-section" initiallyExpanded={true} >
                <DocumentsList 
                  documents={task.reference_documents} 
                  handleOpenDoc={this.handleOpenDoc} 
                  documentType='reference'
                  parentComponentView='task'
                />
                {project &&
                  <DocumentsList
                    documentType='project'
                    documents={project.unique_documents}
                    handleOpenDoc={this.handleOpenDoc} 
                    canDeleteDocuments={false}
                    parentComponentView='task'
                  />}
              </ExpandableSection>
              {
                this.inventoryEnabled &&
                  <TaskInventory 
                    task={task} 
                    items={task.inventory_items} 
                    handlePopupInventoryAdd={this.handlePopupInventoryAdd} 
                    editInventoryItem={this.handleEditInventoryItem}
                  />
              }
            </div>
          }
          {
            this.state.display == 'assignments' &&
            <MobileAssignmentTab 
              parentCompanyId={project.company_id}
              fieldUsers={fieldUsers} 
              isBuildOwner={this.isBuildOwner}
              project={project} 
              task={task}
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(MobileTaskDetails));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/index.js